import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Button,
} from "reactstrap";

import { ColorButtonPicker } from "../../../../../components/ColorButtonPicker";

class EditPlatform extends Component {
  state = {
    platformId: "",
    name: "",
    colorHex: "#4A4A4A",
    showColorPicker: false,
    isPlatform: true,
    description: "",
  };

  handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleChangeColor = (color) => this.setState({ colorHex: color.hex });

  toggleColorPicker = () =>
    this.setState({ showColorPicker: !this.state.showColorPicker });

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.initialValues !== this.props.initialValues) {
      const { initialValues } = nextProps;
      this.setState({
        platformId: initialValues.platformId,
        name: initialValues.name,
        colorHex: initialValues.colorHex,
        isPlatform: initialValues.isPlatform,
        description: initialValues.description,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isOpen !== this.props.isOpen) {
      let me = this;
      setTimeout(() => me.platformIdInput && me.platformIdInput.focus(), 700);
    }
  }

  render() {
    const { isOpen, toggleModal, modalHeader, handleSubmit } = this.props;
    const { showColorPicker, ...restValues } = this.state;

    return (
      <Modal isOpen={isOpen} style={{ minWidth: "550px" }}>
        <ModalHeader toggle={toggleModal}>{modalHeader}</ModalHeader>
        <ModalBody>
          <div
            style={{
              display: "grid",
              gridRowGap: "15px",
            }}
          >
            <div>
              <Label for="platformId">Platform ID</Label>
              <input
                type="text"
                className="form-control"
                ref={(input) => {
                  this.platformIdInput = input;
                }}
                name="platformId"
                placeholder="Platform ID"
                value={restValues.platformId}
                onChange={this.handleChange}
              />
            </div>
            <div>
              <Label for="name">Visible name</Label>
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Visible name"
                value={restValues.name}
                onChange={this.handleChange}
              />
            </div>
            <div>
              <label>
                Platform?
                <input
                  type="checkbox"
                  name="isPlatform"
                  style={{ height: "1em", width: "1em", marginLeft: "1em" }}
                  checked={restValues.isPlatform}
                  onChange={this.handleChange}
                />
              </label>
            </div>
            <div>
              <Label style={{ margin: 0, float: "left" }} for="colorHex">
                Color
              </Label>
              <div style={{ marginLeft: "1em", float: "left" }}>
                <ColorButtonPicker
                  handleChange={this.handleChangeColor}
                  togglePicker={this.toggleColorPicker}
                  showPicker={showColorPicker}
                  colorHex={restValues.colorHex}
                />
              </div>
            </div>
            <div>
              <Label for="name">Description</Label>
              <textarea
                name="description"
                className="form-control"
                value={restValues.description}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div>
              <Button
                color="primary"
                className="float-right"
                style={{ margin: 0 }}
                onClick={() => handleSubmit(restValues)}
              >
                Save
              </Button>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export { EditPlatform };
